import { getAuthTokenForRequest } from './authenticatedClient';

export function captureAssetTransport(scope) {
  const baseUrl = scope.bridge?.localBackendUrl;
  const token = getAuthTokenForRequest(`${baseUrl}/api/desktop/`);
  return { bridge: scope.bridge, baseUrl, current: scope.current,
    config: { headers: { Authorization: token ? `Bearer ${token}` : '' }, suppressServerErrorNotification: true } };
}
export function checkAssetTransport(context) {
  if (context && !context.current()) {
    const error = new Error('Asset request retired before dispatch');
    error.assetNotDispatched = true;
    throw error;
  }
}
